import { createTypedValidator } from '@takeshape/json-schema';
import { ASSET_IMAGE_SHAPE_ID, ASSET_IMAGE_SHAPE_NAME } from "./constants.js";
export const shapeName = ASSET_IMAGE_SHAPE_NAME;
export const shapeId = ASSET_IMAGE_SHAPE_ID;
export const schema = {
    type: 'object',
    properties: {
        url: {
            type: 'string'
        }
    },
    required: ['url'],
    additionalProperties: false
};
export const validate = createTypedValidator(schema);
